export default __webpack_public_path__ + "static/blocks-mobile-ff0bafa58547b7bdb1ff5778ab78066b.svg";